export const SET_HOTEL_ALLOCATION = 'ROOMLIST/SET_HOTEL_ALLOCATION'
export const SET_HOTEL_ALLOCATIONS = 'ROOMLIST/SET_HOTEL_ALLOCATIONS'
